import {
    Box,
    Text
} from 'grommet';

import ResponsiveGrid from "../ResponsiveGrid";

const style = {
    color: '#232C3B',
    textAlign: "center",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
}

const anchorStyle = {
    color: '#232C3B',
    textDecoration: 'none',
}

const determineColor = score => {
    const maxScore = 50;
    const perc = (Number(score) / maxScore) * 100;
    let color;
    if(perc > 80) {color = "#719A57"} else
    if(perc > 60) {color = "#B2DF97"} else
    if(perc > 40) {color = "#F9E195"} else
    if(perc > 20) {color = "#DFB07A"} else {
        color = "#E88986"
    }
return color;
}
function TableRow({data, n, headers}) {
    const url = `https://energydemocracyyall.org/scorecards/coop/?cid=${data.Utility_Number}`
    const len = 75 / (headers.length)
    const column = ["25%"]
    for (let x = 0; x < headers.length; x++) column.push(`${len}%`)
    const columns = {
        small: column,
        medium: column,
        large: column,
    };

    const rows = {
        small: ["auto"],
        medium: ["auto"],
        large: ["auto"],
    };
    return (
        <ResponsiveGrid
            width="100%"
            height="45px"
            overrideColumns={columns}
            overrideRows={rows}
        >
            <Box
                flex={false}
                justify="center"
                style={style}
                pad="small"
            >
                <Text as="a" style={anchorStyle} href={url}>{data.Utility_Name}</Text>
            </Box>
            {headers.map( (header, n) => {
                const styleObj = n === 0 ?
                    {
                        ...style,
                        backgroundColor: determineColor(data[header])
                    }
                    :
                    style
                return (
                    <Box
                        justify="center"
                        style={styleObj}
                        pad="small"
                    >
                        <Text>{data[header]}</Text>
                    </Box>
                )
            })}
        </ResponsiveGrid>
    );
}

export default TableRow;